import type { ChainId } from '@morpho-org/blue-sdk'
import type { Address } from 'viem'

import { isDefined } from '@morpho-org/morpho-ts'

import { READ_ONLY_VAULTS } from '../config'

export interface IsVaultReadOnlyProps {
  chainId: ChainId
  address: Address
}

/**
 * Returns the read-only vault message and whether the vault is read-only.
 *
 * @param chainId - The chain ID of the vault
 * @param address - The address of the vault
 * @returns The read-only vault message and whether the vault is read-only
 */

export const getReadOnlyVault = ({ chainId, address }: IsVaultReadOnlyProps) => {
  const message = READ_ONLY_VAULTS[chainId]?.[address]

  return {
    message,
    isReadOnly: isDefined(message)
  }
}
